import React from 'react';
import styled from 'styled-components';
import { getTranslatedString } from 'helpers/i18n';
import Spacer from 'components/ui/Spacer';
import Row from 'components/ui/Row';
import Col from 'components/ui/Col';
import Form from 'components/ui/Form';
import TextBox from 'components/ui/TextBox';

const FullWidthTextArea = styled(TextBox.TextArea)`
  width: 100%;
`;

const StyledFormItem = styled(Form.Item)`
  margin-top: 30px;
`;

const UtilityDetails = ({ values, errors, touched, setFieldValue }) => {
  const handleChange = event => {
    setFieldValue('utilities.details', event.target.value);
  };

  return (
    <Spacer mb={1}>
      <Row gutter={16}>
        <Col span={24}>
          <StyledFormItem
            label={getTranslatedString('landlordPortal.rentRoll.renewals.utilityDetails')}
            validateStatus={
              touched.utilities?.details && errors.utilities?.details ? 'error' : null
            }
            help={touched.utilities?.details && errors.utilities?.details}
          >
            <FullWidthTextArea
              placeholder={getTranslatedString(
                'landlordPortal.rentRoll.renewals.utilityDetailsInfo'
              )}
              size="large"
              name="utilities.details"
              value={values.utilities.details}
              onChange={handleChange}
            />
          </StyledFormItem>
        </Col>
      </Row>
    </Spacer>
  );
};

export default UtilityDetails;
